import React, { useState } from 'react';
import ArrowsOut from './../../../../assets/images/ArrowsOut.svg';
import styles from './POPriority.module.css'
import ExpandedModal from 'Samarth Module/components/modal/ExpandedModal';
import VerticalMultiBarSimpleChart from 'Samarth Module/components/Charts/VerticalMultiBarSimpleChart';

const POValidityBucket = ({ label, data }) => {
    const [expandedView, setExpandedView] = useState(false);

    // Handler for expanding the graph
    const handleExpand = () => {
        setExpandedView(prev => !prev);
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p className={styles.title}>{label}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div className={styles.arrows_out}>
                        <img src={ArrowsOut} alt='Horizontal Stacked Bar Chart' height={16} width={16} onClick={handleExpand} />
                    </div>
                </div>
            </div>
            <VerticalMultiBarSimpleChart graphData={data} />
            {expandedView && (
                <ExpandedModal onClose={handleExpand} open={expandedView} >
                    <div className={styles.modalContainer}>
                        <p className={styles.title} style={{ marginBottom: '2rem' }}>{label}</p>
                        <VerticalMultiBarSimpleChart graphData={data} />
                    </div>
                </ExpandedModal>
            )}
        </>
    );
};

export default POValidityBucket;